// rolesConfig.ts
import { RoleType } from './roles';

export const getLinksByRole = (role: RoleType) => {
  const allLinks = [
    { title: 'Организации', link: '/organizations', img: 'organizations' },
    { title: 'Объекты', link: '/plants', img: 'plants' },
    { title: 'Модули', link: '/modules', img: 'modules' },
    { title: 'Станции', link: '/stations', img: 'stations' },
    { title: 'Пользователи', link: '/users', img: 'users' },
    { title: 'ADMIN', link: '/admin', img: 'adminIcon' },

  ];

  switch (role) {
    case 'root':
      return allLinks;

    case 'оператор организации':
      return allLinks.filter(link =>
        ['/plants', '/modules', '/stations', '/users'].includes(link.link)
      );

    case 'оператор объекта':
      return []
    // return allLinks.filter(link =>
    //   ['/plants', '/modules', '/stations'].includes(link.link)
    // );

    case 'владелец станции':
      return []; // station_owner видит только личный кабинет, без навигации

    default:
      return [];
  }
};
